/** @format */

export const checkIfValueIsValid = (value) => {
  return value && value != 0 && !Array.isArray(value) && value !== 'undefined';
};
